module.exports = [{"type":"hash","text":"創建API"},{"type":"normal","text":"","children":[{"type":"html","text":"很多接口需要API Key才可以訪問，在對請求進行簽名之前，您必須通過<a href='https://bingx.com' target='_blank'>BingX</a>網站【用戶中心】-【API管理】創建一個API key。 創建key後，您將獲得2個必須記住的信息： API key和Secret key."},{"type":"normal","text":"設置API key的同時，為了安全，建議設置IP訪問白名單."},{"type":"normal","text":"永遠不要把你的API key/Secret key告訴給任何人."}]},{"type":"warning","text":"如果不小心洩露了API key，請立刻删除此API key, 併可以另外生產新的API key."}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/authentication/01_create_api.json
// module id = uqo+
// module chunks = 3